<template>
  <div class="active-query">
    <!-- 搜索区域 -->

    <div class="search-box">
      <div class="input-item">
        <label class="label">考核期</label>
        <DatePicker transfer v-model="searchParams.year" type="year" placement="bottom-start" placeholder="选择年份"></DatePicker>
        <Select style="margin-left: 10px" v-model="searchParams.quarter" clearable placeholder="选择季度">
          <Option :value="1">第一季度</Option>
          <Option :value="2">第二季度</Option>
          <Option :value="3">第三季度</Option>
          <Option :value="4">第四季度</Option>
        </Select>
      </div>
      <div class="input-item">
        <label class="label">IFA名称</label>
        <Select v-model="searchParams.name" clearable filterable>
          <Option v-for="item in userList" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <label class="label">active状态</label>
        <Select v-model="searchParams.activeStatus" clearable placeholder="请选择">
          <Option :value="1">已达标</Option>
          <Option :value="0">未达标</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" border>
        <template slot-scope="{ row }" slot="name">
          <span v-if="row.isLicence === 1" class="dian"></span>
          <span v-else-if="row.isLicence === 2" class="gray"></span>
          <span>{{ row.englishName ? row.englishName + '/' : '' }}{{ row.name }}</span>
        </template>
        <template slot-scope="{ row }" slot="progress">
          <div class="progress-wrapper">
            <Progress :percent="getProgress(row, 0)" :stroke-color="getProgressColor(row)" hide-info style="width: 200px; margin-right: 8px" />
          </div>
          <div>{{ row.fee | numberFormat(0) }}/{{ row.targetFee | numberFormat(0) }} - {{ getProgress(row, 1) || 0 }}%</div>
        </template>
        <template slot-scope="{ row }" slot="activeStatus">
          <Tag v-if="row.activeStatus === '1'" color="success">已达标</Tag>
          <Tag v-else-if="row.activeStatus === '0'" color="error">未达标</Tag>
          <Tag v-else color="warning">待达标</Tag>
          <Tag v-if="row.isEarlyAchievement == '1'" style="margin-left: 8px" color="orange">上季度提前完成</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn primary" @click="handleDetail(row)">详情</span>
          <!-- <span class="table-btn warning" @click="handleChange(row)">变更</span> -->
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>

    <!-- 详情弹窗 -->
    <detailModal ref="detailModal"></detailModal>

    <!-- 变更弹窗 -->
    <changeModal ref="changeModal" @success="getList"></changeModal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool, common } from '@/api/mixins';
import detailModal from './detailModal';
import changeModal from './changeModal';
import Decimal from 'decimal.js';

export default {
  name: 'ActiveQuery',
  components: {
    detailModal,
    changeModal
  },
  props: {
    userList: {
      type: Array,
      default: () => []
    }
  },
  mixins: [pageTool, common],
  data() {
    return {
      // 搜索参数 - 必须定义，pageTool 的 getList 会基于此构造请求参数
      searchParams: {
        name: '',
        activeStatus: '',
        year: '',
        quarter: ''
      },
      columns: [
        {
          title: '序号',
          align: 'center',
          type: 'index',
          width: 80
        },
        {
          title: 'IFA姓名',
          slot: 'name',
          align: 'center',
          width: 160
        },
        {
          title: '所属团队',
          key: 'groupName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            return h('span', {}, params.row.groupName || '-');
          }
        },
        {
          title: '入职时间',
          key: 'entryTime',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('span', {}, params.row.entryTime ? dayjs(params.row.entryTime).format('YYYY-MM-DD') : '-');
          }
        },
        {
          title: '考核期',
          key: 'assessmentPeriod',
          align: 'center',
          minWidth: 190,
          render: (h, params) => {
            const row = params.row;
            return h('span', {}, `${dayjs(row.checkStartTime).format('YYYY-MM-DD')} 至 ${dayjs(row.checkEndTime).format('YYYY-MM-DD')}`);
          }
        },
        {
          title: '标保 (美元)',
          key: 'fee',
          align: 'center',
          minWidth: 120
        },
        {
          title: '当季度达标进度',
          slot: 'progress',
          align: 'center',
          width: 260
        },
        {
          title: '当季度active状态',
          slot: 'activeStatus',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 140,
          fixed: 'right'
        }
      ]
    };
  },
  filters: {
    numberFormat(value, precision = 2) {
      if (!value) return '-';
      return new Decimal(value).toFixed(precision);
    }
  },
  mounted() {
    // 初始化列表参数和API地址，并立即加载列表数据
    this.initListAjax('/buz/userActiveRecord/read/list');
  },
  methods: {
    /**
     * 查看详情
     */
    handleDetail(row) {
      this.$refs.detailModal.open(row);
    },
    setListParams(params) {
      if (params.year) {
        params.year = dayjs(params.year).format('YYYY');
      }
    },

    /**
     * 变更操作
     */
    handleChange(row) {
      this.$refs.changeModal.open(row);
    },
    checkParams(params) {
      if (!params.year && params.quarter) {
        this.$notice.error('请选择考核期年份');
        return false;
      }
      return true;
    },
    /**
     * 获取进度值
     * @param {Object} row - 行数据
     * @param {number} type - 0:进度条百分比(上限100) 1:实际百分比
     * @returns {number}
     */
    getProgress(row, type) {
      const fee = row.fee || 0;
      const targetFee = row.targetFee || 0;
      if (!targetFee) return 0;
      let val = new Decimal(fee).div(targetFee).toNumber();
      if (val > 1 && type === 0) return 100;
      return new Decimal(val).mul(100).round().toNumber();
    },

    /**
     * 获取进度条渐变颜色
     * 返回 iView Progress 组件支持的渐变色对象格式 { '0%': '#深色', '100%': '#浅色' }
     * 实现从左到右、由深至浅的平滑颜色过渡
     * @param {Object} row - 行数据
     * @returns {Object} 渐变色对象
     */
    getProgressColor(row) {
      const activeStatus = row.activeStatus;
      // 已达标：深绿 → 浅绿
      if (activeStatus === '1') return ['#a3e4b8', '#19be6b'];
      // 未达标：深红 → 浅红
      if (activeStatus === '0') return ['#f5a99a', '#ed4014'];
      // 待达标：深橙 → 浅橙
      return ['#ffcc66', '#ff9900'];
    }
  }
};
</script>

<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
}
.gray {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 4px;
  background-color: #aba2a2;
}
</style>
